<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h1 class="u">Скидки <router-link class="btn btn-primary" :to="{ name: 'discount-add' }">+ Добавить скидку</router-link></h1>

    <div class="sub-nav">
      <router-link class="btn btn-default btn-sm" :to="{ name: 'settings' }">← Назад к Настройкам</router-link>
    </div>

    <resource-list
      url="/discounts"
      current-sort="name"
      resource-name="discounts"
      :action-routes="actionRoutes"
      :fields="fields"
      :filters="filters"
    />

  </div>
</template>

<script>
import resourceList from '@/components/ResourceList'

export default {
  name: 'discounts',
  components: { resourceList },
  data () {
    return {
      fields: [
        { name: 'name', label: 'Название', sort: true },
        { name: 'amount', label: 'Сумма', sort: true, money: true },
        { name: 'start_date', label: 'Дата начала', sort: true, datetime: true },
        { name: 'end_date', label: 'Дата окончания', sort: true, datetime: true }
      ],
      filters: {
        name: ''
      },
      actionRoutes: [
        { name: 'discount-details', label: 'Открыть детали' }
      ]
    }
  }
}
</script>


// WEBPACK FOOTER //
// Discounts.vue?2839edb8